var _module = require('../components/module.js');

_module.filter('mergeVars', [
    '$log',
    '$interpolate',

    function ($log, $interpolate) {
        return function mergeVars(str, scope) {
            return $interpolate(str)(scope);
        };
    }
]);
